var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ProductsList"},[_c('div',{staticClass:"container px-0"},[(_vm.$_cmsSupport_hasContentSlotWithName('product'))?_c('div',{staticClass:"row"},[_vm._t("product")],2):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }